export default {
  // 模块名称
  account: {
    // 按钮类
    button: {
      add: '新增',
      batchDel: '批量删除',
      reset: '重置',
      query: '查询',
      save: '保存',
      cancel: '取消',
      edit: '修改',
      delete: '删除',
      confirm: '确认',
      setPermission: '权限设置',
      relation: '账户关联',
      back: '返回'
    },
    // 文字标签类
    label: {
      accountGroup: '账户组名',
      remark: '备注',
      creator: '创建人',
      createTime: '创建时间',
      lastModifyTime: '最后修改时间',
      operations: '操作',
      functionPermission: '功能权限',
      deviceName: '设备名称',
      deviceType: '全设备类型',
      showPermission: '查看权限',
      operatePermission: '操作权限',
      areaDevicePermission: '区域设备权限'
    },
    // 提示类
    placeholder: {
      accountGroup: '请输入账户组名',
      remark: '请输入备注'
    },
    // 消息类
    message: {
      accountGroup: '请输入账户组名',
      remark: '请输入备注',
      less30: '账户组名的长度在 4 到 30 个字符',
      formatAccount: '账户组名只包括字母、数字、汉字、下划线',
      less200: '备注信息不能超过200个字符',
      setSuccess: '账户组设置账户成功',
      deltips: '此操作将永久删除选择的账户组, 是否继续?',
      batchDel: '账户组批量删除成功',
      selecttips: '请选择要删除的账户组',
      delSuccess: '删除成功',
      addSuccess: '账户组创建成功',
      editSuccess: '账户组修改成功',
      setPermissionSuccess: '账户设置权限成功'
    },
    // 标题类
    title: {
      warn: '提示',
      resetPW: '重置密码',
      addAccountGroup: '新增账户组',
      editAccountGroup: '修改账户组',
      relations: '账户隶属账户组管理',
      selectableRole: '角色列表',
      selectedRole: '已选角色'
    }
  }
}